// The booking API reads the portion before the first slash as the S3 bucket.
// CRM media stores bucket and key separately; older references may already be qualified.
export const crmIdentityMediaReference = (media) => {
  if (!media || !media.key) return '';
  if (!media.bucket || media.key.startsWith(`${media.bucket}/`)) return media.key;
  return `${media.bucket}/${media.key.replace(/^\/+/, '')}`;
};



// WEBPACK FOOTER //
// ./src/utils/crmIdentityMedia.js